import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gradClass',
    standalone: false
})
export class GradClassPipe implements PipeTransform {

  transform(value: number): string {
    return 'igrad-' + (value % 12);
  }

}
